export type {
  QuickBooksInvoice,
  QuickBooksCustomer,
  QuickBooksInvoicesResponse,
  QuickBooksCustomersResponse,
} from "@/lib/types/quickbooks-unified";
export type { MultiCompanyResult, MultiCompanyItem } from "@/lib/integrations/quickbooks/quickbooks-multi-company-utils";

export type { QuickBooksConnectionStatus } from "@/lib/types/quickbooks-unified";
export { useQuickBooksConnectionStatus, useQuickBooksTokens } from "./quickbooks-connection";
export { useQuickBooksEntity, useUpdateQuickBooksEntity, useCreateQuickBooksEntity } from "./quickbooks-entities";
export {
  useQuickBooksEntitiesMultiCompany,
  useQuickBooksEntitiesByCustomerMultiCompany,
  useQuickBooksInvoicesByMultipleCustomersMultiCompany,
} from "./quickbooks-multi-company";
export { useSyncTimeEntryToQuickBooks, useBulkSyncTimeEntries } from "./quickbooks-time-activities";

import { useQuickBooksEntity, useCreateQuickBooksEntity, useUpdateQuickBooksEntity } from "./quickbooks-entities";
import { useQuickBooksEntitiesMultiCompany, useQuickBooksEntitiesByCustomerMultiCompany } from "./quickbooks-multi-company";

export const useQuickBooksInvoice = (invoiceId: string, realmId?: string) =>
  useQuickBooksEntity(invoiceId, "invoice", realmId);

export const useCreateQuickBooksInvoice = () => useCreateQuickBooksEntity("invoice");

export const useUpdateQuickBooksInvoice = () => useUpdateQuickBooksEntity("invoice");

export const useQuickBooksInvoicesMultiCompany = () =>
  useQuickBooksEntitiesMultiCompany("invoices");

export const useQuickBooksCustomersMultiCompany = () =>
  useQuickBooksEntitiesMultiCompany("customers");

export const useQuickBooksInvoicesByCustomerMultiCompany = (
  customerName?: string,
  customerId?: string,
  realmId?: string
) => useQuickBooksEntitiesByCustomerMultiCompany("invoices", customerName, customerId, realmId);
